// src/pages/ContactUs.js

import React from 'react';
import GoogleMapsForm from '../components/GoogleMapsForm';
import ContactUsForm from '../components/backend/ContactUsForm';

const ContactUs = () => {
  return (
    <div>
      <div className="main">
        <div className="column1"></div>
        <div className="column2">
          <div className="page-header">
            <h1>Contact Us</h1>
                      <i>"Join the next stage of human evolution and become more than human."</i>
          </div>
          <div className="panel spaced">
            <h3>Trading Hours (by appointment only)</h3>
            <ul>
              <li><strong>Monday - Sunday:</strong> 9:00 AM - 5:00 PM</li>
            </ul>
            <h3>Address (by appointment only)</h3>
            <p>B1/13-21 Mandible St<br />Alexandria NSW 2015, Australia</p>
            <h3>Email</h3>
            <p><a href="mailto:support@sabrenetics.com">support@sabrenetics.com</a></p>
            <h3>Mobile</h3>
            <p><a href="tel:+61452008019">+61 452 008 019</a></p>
          <div className="map-wrapper">
            <GoogleMapsForm />
          </div>
          </div>
          <div className="panel spaced">
            <h3>Contact Us Form</h3>
            <ContactUsForm />
          </div>
        </div>
        <div className="column3"></div>
      </div>
    </div>
  );
};

export default ContactUs;
